import {
  Component,
  OnInit,
  Input,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
interface carouselImage {
  file_name: string;
  imageAlt: string;
  is360?: boolean; // Indica si es una vista 360
}
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
  constructor(private cdr: ChangeDetectorRef) {}

  // Soporte para teclas de flecha
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.images && this.images.length > 1) {
      if (event.key === 'ArrowLeft') {
        this.onPrevClick();
      } else if (event.key === 'ArrowRight') {
        this.onNextClick();
      }
    }
  }

  @Input() images: carouselImage[] = [];
  @Input() indicators = false;
  @Input() imgIndicators = true;
  @Input() controls = true;
  @Input() images360: string[] = []; // Array de imágenes 360
  @Input() productName: string = ''; // Nombre del producto para el visor 360
  selectedIndex = 0;
  isModalOpen = false; // Controla si el modal está abierto
  zoomImageSrc: string = ''; // Contendrá la URL de la imagen de zoom

  ngOnInit(): void {}

  // Método para abrir el modal y mostrar la imagen de zoom
  openZoomModal(event: MouseEvent | TouchEvent): void {
    // Siempre prevenir si hay un touch activo
    if (this.preventClick) {
      return;
    }

    // No abrir modal para imágenes 360, solo para imágenes normales
    if (this.images && this.images.length > 0) {
      const currentImage = this.images[this.selectedIndex];
      if (!currentImage.is360) {
        this.zoomImageSrc = this.images[this.selectedIndex].file_name;
        this.isModalOpen = true;
      }
    }
  }

  // Método para cerrar el modal
  closeZoomModal(): void {
    this.isModalOpen = false; // Cierra el modal
  }

  // Actualizar la imagen del zoom cuando cambia la selección
  private updateZoomImage(): void {
    if (this.isModalOpen && this.images && this.images.length > 0) {
      const currentImage = this.images[this.selectedIndex];
      if (!currentImage.is360) {
        this.zoomImageSrc = this.images[this.selectedIndex].file_name;
      }
      // Si es 360, el modal mostrará el visor 360
    }
  }

  // Verificar si la imagen actual es 360
  isCurrentImage360(): boolean {
    if (
      this.images &&
      this.images.length > 0 &&
      this.selectedIndex < this.images.length
    ) {
      const is360 = this.images[this.selectedIndex].is360 === true;
      return is360;
    }
    return false;
  }

  selectImage(index: number): void {
    this.selectedIndex = index;
    this.updateZoomImage();
    // Forzar detección de cambios
    this.cdr.detectChanges();
  }
  onPrevClick(): void {
    if (this.selectedIndex === 0) {
      this.selectedIndex = this.images.length - 1;
    } else {
      this.selectedIndex--;
    }
    this.updateZoomImage();
  }
  onNextClick(): void {
    if (this.selectedIndex === this.images.length - 1) {
      this.selectedIndex = 0;
    } else {
      this.selectedIndex++;
    }
    this.updateZoomImage();
  }
  touchStartX: number = 0;
  touchEndX: number = 0;
  touchStartTime: number = 0;
  preventClick: boolean = false;
  imageIndexAtTap: number = -1;

  onTouchStart(event: TouchEvent) {
    // Verificar que el toque esté en la imagen visible, no en espacios vacíos
    const target = event.target as HTMLElement;
    const isImage = target.tagName === 'IMG' || target.closest('img');

    if (!isImage) {
      return;
    }

    this.touchStartX = event.touches[0].clientX;
    this.touchEndX = event.touches[0].clientX;
    this.touchStartTime = Date.now();
    this.preventClick = true; // Siempre prevenir el click cuando hay touch
    this.imageIndexAtTap = this.selectedIndex; // Capturar el índice al inicio del tap
  }

  onTouchMove(event: TouchEvent) {
    this.touchEndX = event.touches[0].clientX;
    const currentDiff = Math.abs(this.touchStartX - this.touchEndX);
    // Prevenir scroll si hay movimiento horizontal significativo
    if (currentDiff > 10) {
      event.preventDefault();
    }
  }

  onTouchEnd(event?: TouchEvent) {
    const diff = this.touchStartX - this.touchEndX;
    const minSwipeDistance = 50;
    const maxTapMovement = 20; // Movimiento máximo para considerar un tap
    const touchDuration = Date.now() - this.touchStartTime;

    if (Math.abs(diff) > minSwipeDistance && touchDuration < 500) {
      // Es un swipe - cambiar imagen y NO abrir modal
      event?.preventDefault();
      if (diff > 0) {
        // Swipe left - next image
        this.onNextClick();
      } else {
        // Swipe right - previous image
        this.onPrevClick();
      }

      // Mantener preventClick activo
      setTimeout(() => {
        this.preventClick = false;
      }, 500);
    } else if (Math.abs(diff) <= maxTapMovement) {
      // Es un tap limpio - abrir modal inmediatamente con la imagen correcta
      event?.preventDefault();
      this.openModalWithImage(this.imageIndexAtTap);

      // Mantener preventClick por un tiempo para evitar el click event
      setTimeout(() => {
        this.preventClick = false;
      }, 500);
    } else {
      // Movimiento intermedio - no hacer nada (ni swipe ni tap)
      event?.preventDefault();
      setTimeout(() => {
        this.preventClick = false;
      }, 300);
    }
  }

  // Método auxiliar para abrir el modal con un índice específico
  private openModalWithImage(index: number): void {
    if (
      this.images &&
      this.images.length > 0 &&
      index >= 0 &&
      index < this.images.length
    ) {
      this.selectedIndex = index;
      const currentImage = this.images[index];
      // El 360 se ve en el carrusel; no abrir zoom vacío sobre esa slide
      if (currentImage.is360) {
        return;
      }
      this.zoomImageSrc = currentImage.file_name;
      this.isModalOpen = true;
    }
  }
}
